import { createFeatureSelector } from '@ngrx/store';
import { configFeatureKey, State } from '../../filters/reducers/filter.reducer';

export const selectFilter = createFeatureSelector<State>(configFeatureKey);
